import React from 'react';
import Layout from '../Layout';
import css from './ParentInviteComplete.module.scss';
import { useUser } from '../../state/user';

const ParentInviteComplete = () => {
  const { userIsTeen } = useUser();
  return (
    <Layout data-e2e="parent-invite-complete-container">
      <div className={css.ParentInviteCompleteMainBox}>
        <h1 data-e2e="header">You’re almost there!</h1>
        <img src={'../../../static/end-of-reg.svg'} alt="Greenlight card app" />
        <p data-e2e="need-adult-legal">
          Your parent or guardian has been invited to complete your Greenlight
          setup.
        </p>
        {userIsTeen && (
          <div
            className={css.ParentInviteStores}
            data-e2e="store-apps-container"
          >
            <p>In the meantime, download the app and start exploring.</p>
            <div>
              <img src={'../../../static/apple-app-store.svg'} />
              <img src={'../../../static/google-play-store.svg'} />
              <img src={'../../../static/amazon-app-store.svg'} />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
export default ParentInviteComplete;
